import { render, staticRenderFns } from "./AuthenticationRegister.vue?vue&type=template&id=b549a78e&"
import script from "./AuthenticationRegister.vue?vue&type=script&lang=js&"
export * from "./AuthenticationRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports